import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const ClassHealthRosterQuery = graphql.persisted(
  "ClassHealthRosterQuery",
  graphql(`
    query ClassHealthRosterQuery($classOfferingId: ID!) {
      classHealthRoster(classOfferingId: $classOfferingId) {
        classOfferingId
        displayName
        students {
          studentId
          firstName
          lastName
          dateOfBirth
          allergies
          medicalCondition
        }
      }
    }
  `)
);

export { ClassHealthRosterQuery };

export function useClassHealthRosterQuery(classOfferingId?: string, enabled = false) {
  return useQuery(ClassHealthRosterQuery, {
    variables: { classOfferingId: classOfferingId! },
    skip: !classOfferingId || !enabled,
    // Health data is both sensitive and roster-dependent. Fetch it for each
    // explicit view/print action instead of retaining a reusable Apollo copy.
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
  });
}
